export interface IBusinessUnit {
  type: 'dso' | 'reseller' | 'axi' | 'invisalign' | 'itero' | 'tps' | 'service' | 'exocad' | 'chemical-compliance';
}



export const databaseConnectionMap: Record<IBusinessUnit['type'], string> = {
  reseller: 'reseller',
  exocad: 'exocad',
  dso: 'dso',
  axi: 'axi',
  invisalign: 'invisalign',
  itero: 'itero',
  tps: 'tps',
  service: 'service',
  'chemical-compliance': 'chemical-compliance',
};

export const pingSubRealmMap: Partial<Record<IBusinessUnit['type'], string>> = {
  exocad: 'exocad',
  invisalign: 'invisalign',
  tps: 'invisalign',
  itero: 'itero',
};

export const getPingSubRealm = (businessUnit?: string) =>
  businessUnit
    ? pingSubRealmMap[businessUnit as IBusinessUnit['type']]
    : undefined;



export const parseCallbackUrlForBusinessUnit = (
  url: string,
): IBusinessUnit['type'] | null => {
  let pathname: string;
  try {
    pathname = new URL(url, 'http://localhost').pathname;
  } catch {
    pathname = url;
  }
  return /\/dso/.test(pathname)
    ? 'dso'
    : /\/reseller/.test(pathname)
    ? 'reseller'
    : /\/exocad/.test(pathname)
    ? 'exocad'
    : /\/axi/.test(pathname)
    ? 'axi'
    : /\/invisalign/.test(pathname)
    ? 'invisalign'
    : /\/itero/.test(pathname)
    ? 'itero'
    : /\/tps/.test(pathname)
    ? 'tps'
    : null;
};

export const clientDisplayNameMap: Record<IBusinessUnit['type'], string> = {
  reseller: 'exocad Partner Portal',
  exocad: 'Exocad Partner Portal',
  dso: 'Align Special Markets Portal',
  axi: 'AXI Partner Portal',
  invisalign: 'Invisalign® Doctor Site',
  itero: 'Itero® Partner Portal',
  tps: 'Invisalign® Doctor Site',
  service: 'Service Account',
  'chemical-compliance': 'Supplier Product Compliance',
};
